/*
 * Copyright (c) 2024-2025. Haodong JU
 */

import EntitySelector from './EntitySelector.vue'
import EntitySelectorExample from './EntitySelectorExample.vue'
import { createEntitySelectorSchema, createProductSelectorSchema } from './entitySelectorUtils'
import { createAssetSelectorSchema } from './createAssetDialog'

export {
  EntitySelector,
  EntitySelectorExample,
  createEntitySelectorSchema,
  createProductSelectorSchema,
  createAssetSelectorSchema
}

export default EntitySelector
